__turbopack_context__.v({
  "author": "Related-module-scss-module__YHRbQG__author",
  "blink": "Related-module-scss-module__YHRbQG__blink",
  "four": "Related-module-scss-module__YHRbQG__four",
  "full": "Related-module-scss-module__YHRbQG__full",
  "fullContent": "Related-module-scss-module__YHRbQG__fullContent",
  "fullImage": "Related-module-scss-module__YHRbQG__fullImage",
  "fullImageContain": "Related-module-scss-module__YHRbQG__fullImageContain",
  "fullJournal": "Related-module-scss-module__YHRbQG__fullJournal",
  "fullText": "Related-module-scss-module__YHRbQG__fullText",
  "h1": "Related-module-scss-module__YHRbQG__h1",
  "list": "Related-module-scss-module__YHRbQG__list",
  "one": "Related-module-scss-module__YHRbQG__one",
  "related": "Related-module-scss-module__YHRbQG__related",
  "three": "Related-module-scss-module__YHRbQG__three",
  "title": "Related-module-scss-module__YHRbQG__title",
  "two": "Related-module-scss-module__YHRbQG__two",
});
